import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, LogIn } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";
import SEO from "@/components/SEO";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const signIn = () => {
    // Land back on /auth/callback to process the session_id hash
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0f1512] text-white" data-testid="login-page">
      <SEO title="Seller Sign-in | Vacations Pro" description="Secure seller access." path="/login" noindex />
      <header className="border-b border-white/10 px-6 md:px-10 py-5 flex items-center">
        <Link to="/" className="flex items-center gap-2 text-white/70 hover:text-white text-xs tracking-[0.2em] uppercase">
          <ArrowLeft className="w-3.5 h-3.5" /> Home
        </Link>
      </header>

      <div className="flex items-center justify-center px-6 py-24">
        <div className="max-w-md w-full text-center">
          <span className="vp-label text-white/60 mb-3 block">SELLER DESK · PRIVATE</span>
          <h1 className="font-serif-vp text-4xl md:text-5xl mb-4">Sign in to continue</h1>
          <p className="text-white/60 text-sm mb-10">
            Only whitelisted emails can access the lead inbox. If you're the owner, use your Google account below.
          </p>
          <button
            onClick={signIn}
            className="w-full flex items-center justify-center gap-3 bg-white text-[#0f1512] rounded-md py-3.5 font-medium text-sm tracking-wide hover:bg-white/90 transition"
            data-testid="google-signin-btn"
          >
            <LogIn className="w-4 h-4" />
            Continue with Google
          </button>
          <p className="text-[11px] text-white/40 mt-6 tracking-wide">
            You'll be redirected to Google, then back here.
          </p>
        </div>
      </div>
    </div>
  );
}
